<script lang="ts" module>
  import { get } from 'svelte/store';

  import NavButton from '@/ui/elements/buttons/NavButton.svelte';
  import { useCoreStateAnalysisUsageQuotaInfo } from '@/ui/state/use-core-state.svelte';
  import { useActiveTextReadable, useActiveTextState } from '@/ui/state/use-text-state.svelte';
  import { useTeoCore } from '@/utils/teo-context';
  import { useAnalysisState } from '@/utils/teo-context/teo-atoms/analysis';
  import { useActiveTextUIView } from '@/utils/teo-context/teo-atoms/text';
</script>

<script lang="ts">
  const S = useActiveTextState();
  const activeText = useActiveTextReadable();

  const analysisState = useAnalysisState();
  const teoCore = useTeoCore();
  const [selectedView, setSelectedView] = useActiveTextUIView();

  function gotoVersions() {
    setSelectedView('versions');
  }

  const handleClick = $derived(() => {
    const needsAnalysis = !analysisState.current.isCurrent;
    const analysisQuotaInfo = get(useCoreStateAnalysisUsageQuotaInfo());

    if (needsAnalysis) {
      const notificationNeedsAnalysis = teoCore.notifications.add({
        title: 'Versionen',
        message: `Der aktuelle Text wurde noch nicht zur Versionshistorie hinzugefügt. 
           Hierzu muss zunächst eine Analyse durchgeführt werden.`,
        mode: 'warning',
        buttons: [
          {
            label: 'Abbrechen',
            variant: 'secondary',
            onclick: () => {
              teoCore.notifications.close(notificationNeedsAnalysis);
            },
          },
          {
            label: `Analyse starten ${analysisQuotaInfo?.text ?? ''}`,
            variant: 'primary',
            disabled: analysisQuotaInfo?.depleted ?? false,
            onclick: () => {
              $activeText
                ?.analyze({ trigger: 'button_click' })
                .then(() => {
                  teoCore.notifications.close(notificationNeedsAnalysis);
                  gotoVersions();
                })
                .catch(() => {
                  teoCore.notifications.close(notificationNeedsAnalysis);
                });
              return 'keep';
            },
          },
        ],
      });
    } else {
      gotoVersions();
    }
  });
</script>

<NavButton
  label="Versionen"
  icon="History"
  onclick={handleClick}
  selected={selectedView.current == 'versions'}
  disabled={$S?.view === 'new' || $S?.view === 'text-generator'}
/>
